import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
  Input,
  Space,
  Modal,
  Upload,
  message,
  Form,
} from "antd";
import { PlusOutlined, LinkOutlined, DeleteOutlined } from "@ant-design/icons";
import shortId from "shortid";
import { useDebouncedCallback } from "use-debounce";
import ImgCrop from "antd-img-crop";
import imageCompression from "browser-image-compression";
import _ from "lodash";

import { Domain } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import { request } from "../../../../config/API";
import authHeader from "../../../../redux/services/authHeader";

const iconNames = require("../../../../helpers/ICONS.json");

const { danger } = COLORS;
const { Search } = Input;

const Websites = ({ form }) => {
  const [websites, setWebsites] = useState([]);
  const [iconModal, setIconModal] = useState("");

  const handleRemoveIcon = (_id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        existingWebsites[index] = {
          ...existingWebsites[index],
          icon: "",
        };
      }
    }
    setWebsites(existingWebsites);
  };

  const handleRemoveCustomIcon = (image, _id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        existingWebsites[index] = {
          ...existingWebsites[index],
          image: "",
        };
      }
    }
    setWebsites(existingWebsites);
  };
  const onWebsiteValueChange = (e, _id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        existingWebsites[index] = {
          ...existingWebsites[index],
          [e.target.name]: e.target.value,
        };
      }
    }
    setWebsites(existingWebsites);
  };
  const handleremoveWebLink = (_id) => {
    const webLink = websites.find((link) => link._id === _id);

    const tempWebLinks = websites.filter((link) => link._id !== _id);
    if (webLink?.image) {
      handleRemoveCustomIcon(webLink.image, _id);
    }
    setWebsites(tempWebLinks);
  };
  const handleAddNewWebLink = () => {
    setWebsites([
      ...websites,
      { _id: shortId(), name: "", link: "", icon: "", image: "" },
    ]);
  };

  const [searchIconValue, setSearchIconValue] = useState("");
  const [searchedIcon, setSearchIcons] = useState([]);
  const handleSearchIcon = () => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    const searchedIcon = iconNames.filter((item) => {
      return item.match(searchIconValue.toLowerCase());
    });
    if (searchedIcon.length > 0) {
      setSearchIcons(searchedIcon);
    } else {
      setSearchIcons([]);
    }
  };
  const debounced = useDebouncedCallback(() => {
    handleSearchIcon();
  }, 500);

  useEffect(() => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    debounced(searchIconValue);
  }, [debounced, searchIconValue]);

  const handleAddIcon = (_id, icon) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        existingWebsites[index] = {
          ...existingWebsites[index],
          icon: icon,
        };
      }
    }
    setIconModal("");
    setWebsites(existingWebsites);
  };
  const controller = new AbortController();
  const handleAddCustomIcon = ({ file, onSuccess, onError }, _id) => {
    const options = {
      signal: controller.signal,
      maxSizeMB: 0.05,
    };
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("customIcon", compressedFile);
        request
          .post("qr/images", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              ...authHeader(),
            },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const existingWebsites = [...websites];
            for (let index = 0; index < websites.length; index++) {
              if (_id === existingWebsites[index]?._id) {
                existingWebsites[index] = {
                  ...existingWebsites[index],
                  image: data.customIcon,
                };
              }
            }

            setIconModal("");
            setWebsites(existingWebsites);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
          });
        return;
      })
      .catch(function (error) {
        console.error(error.message);
      });
  };

  useEffect(() => {
    form.setFieldValue(
      "webLinks",
      websites.map((web) => _.omit(web, ["_id"]))
    );
  }, [form, websites]);

  return (
    <>
      <Row span={24} align="space-between">
        <Col xs={24} md={4}>
          <h4>Weblinks</h4>
          <p className="subText">
            Please Input your website link in the first field.
          </p>
          <p
            style={{
              color: danger,
              fontSize: 11,
              fontWeight: "500",
            }}
          >
            * First Link will be saved in your vcf file{" "}
          </p>
        </Col>
        <Col xs={24} md={19}>
          <div style={{ marginBottom: "1rem" }}>
            {websites.map((website, index) => {
              return (
                <Space key={index} wrap={true} style={{ marginBottom: "1rem" }}>
                  {website?.icon ? (
                    <i
                      onClick={() => {
                        handleRemoveIcon(website._id);
                      }}
                      className={`fas fa-${website?.icon} fa-2x`}
                      style={{
                        margin: "1rem",
                        cursor: "pointer",
                      }}
                    />
                  ) : website?.image ? (
                    <img
                      onClick={() => {
                        handleRemoveCustomIcon(website.image, website._id);
                      }}
                      src={Domain + "/data/" + website.image}
                      style={{
                        width: "2rem",
                        height: "2rem",
                        cursor: "pointer",
                        margin: "1rem",
                      }}
                      alt="icon"
                    />
                  ) : (
                    <Button
                      size="large"
                      onClick={() => setIconModal(website._id)}
                      style={{ borderRadius: 8 }}
                    >
                      Icon
                    </Button>
                  )}

                  <Input
                    name="name"
                    style={{ borderRadius: 8 }}
                    placeholder="Link"
                    size="large"
                    // value={website.name}
                    onChange={(e) => onWebsiteValueChange(e, website._id)}
                  />

                  <Input
                    name="link"
                    style={{ borderRadius: 8 }}
                    size="large"
                    // value={website.link}
                    placeholder="www.mywebsiteurl.com"
                    prefix={
                      <>
                        <LinkOutlined style={{ paddingRight: 5 }} /> https://
                      </>
                    }
                    onChange={(e) => onWebsiteValueChange(e, website._id)}
                  />

                  <Button
                    size="large"
                    danger
                    onClick={() => {
                      handleremoveWebLink(website._id);
                    }}
                    style={{ borderRadius: 8 }}
                    icon={
                      <DeleteOutlined
                        className="linkDeleteIcon"
                        style={{ fontSize: 18 }}
                      />
                    }
                  >
                    Remove
                  </Button>
                </Space>
              );
            })}
          </div>
          <Button
            type="dashed"
            onClick={() => {
              handleAddNewWebLink();
            }}
            block
            icon={<PlusOutlined />}
            style={{ borderRadius: 8, marginBottom: "2rem" }}
          >
            Add Links
          </Button>
        </Col>
      </Row>
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ paddingLeft: "2rem", paddingRight: "2rem" }}
        visible={!!iconModal}
        title="Choose Weblink Icon"
        footer={null}
        onCancel={() => setIconModal("")}
      >
        <Search
          placeholder="Search Icon"
          onSearch={() => {
            handleSearchIcon();
          }}
          value={searchIconValue}
          onChange={(e) => {
            setSearchIconValue(e.target.value);
          }}
          enterButton
        />
        <div style={{ marginTop: "1rem", padding: "1rem" }}>
          {searchedIcon?.length > 0 ? (
            <Space wrap={true}>
              {searchedIcon?.slice(0, 20).map((icon) => (
                <i
                  onClick={() => {
                    handleAddIcon(iconModal, icon);
                  }}
                  key={icon}
                  className={`fas fa-${icon} fa-2x`}
                  style={{ margin: "1rem", cursor: "pointer" }}
                />
              ))}
            </Space>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <p>
                {searchIconValue.length > 0 ? "No Icon Found" : "Search Icon"}
              </p>

              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginTop: ".5rem",
                  marginBottom: ".5rem",
                }}
              >
                OR
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <p>Upload Custom Icon</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <ImgCrop
                    rotate
                    modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                    quality={1}
                    shape="rect"
                    fillColor="#00000000"
                  >
                    <Upload
                      className="fileList-upload-images"
                      maxCount={1}
                      customRequest={(e) => {
                        handleAddCustomIcon(e, iconModal);
                      }}
                      fileList={[]}
                      listType="picture-card"
                      accept="image/png"
                    >
                      <PlusOutlined />
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
      <Form.Item name="webLinks">
        <Input type="hidden"></Input>
      </Form.Item>
    </>
  );
};

export default Websites;
